export default "__VITE_ASSET__d085bf59__"